export const Features = [
  "Custom Software",
  "Web Application",
  "Mobile Application",
  "Enterprise Software",
  "Software Consulting",
  "Maintenance and Support",
];

export const WorkSteps = [
  {
    icon: "https://appthing-website.s3.ap-south-1.amazonaws.com/work-icon-01.svg",
    title: "Requirements Gathering",
    text: "Understanding business needs and collecting detailed requirements.",
    delay: "200ms",
  },
  {
    icon: "https://appthing-website.s3.ap-south-1.amazonaws.com/work-icon-02.svg",
    title: "Analysis and Planning",
    text: "Analyzing requirements and planning the architecture & roadmap.",
    delay: "300ms",
  },
  {
    icon: "https://appthing-website.s3.ap-south-1.amazonaws.com/work-icon-03.svg",
    title: "Design & Development",
    text: "UI/UX design, coding, and integrating system modules.",
    delay: "400ms",
  },
  {
    icon: "https://appthing-website.s3.ap-south-1.amazonaws.com/work-icon-04.svg",
    title: "Testing & Release",
    text: "Quality assurance, bug fixing, and deployment.",
    delay: "500ms",
  },
  {
    icon: "https://appthing-website.s3.ap-south-1.amazonaws.com/work-icon-05.svg",
    title: "Maintenance & Support",
    text: "Continuous support, updates, and improvements.",
    delay: "600ms",
  },
];
